import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class SalesforceService {
  async getAccountsSalesforce() {
    return await axios
      .get(API_URL + "/SalesForce/CheckSalesForceAccess")
      .then(response => {
        if (response.data.success) {
          axios.get(API_URL + "/SalesForce/GetAccounts").then(response => {
            store.commit("salesForce/updateAccounts", response.data);
          });
        } else {
          location.href = response.data.redirectUrl;
        }
      });
  }

  async postNewsSelection(data) {
    return await axios
      .post(API_URL + "SalesForce/PostNewsSelection", {
        itemsList: data
      })
      .then(response => {
        console.log("resp is  ", response);
      })
      .catch(error => {
        console.log("ERROR:  ", error);
      });
  }
}

export default new SalesforceService();
